/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentMentionNotificationActionData } from './CommentMentionNotificationActionData';
import {
    CommentMentionNotificationActionDataFromJSON,
    CommentMentionNotificationActionDataFromJSONTyped,
    CommentMentionNotificationActionDataToJSON,
} from './CommentMentionNotificationActionData';

/**
 * 
 * @export
 * @interface CommentMentionNotificationAction
 */
export interface CommentMentionNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof CommentMentionNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CommentMentionNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {CommentMentionNotificationActionData}
     * @memberof CommentMentionNotificationAction
     */
    data: CommentMentionNotificationActionData;
}

/**
 * Check if a given object implements the CommentMentionNotificationAction interface.
 */
export function instanceOfCommentMentionNotificationAction(value: object): value is CommentMentionNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CommentMentionNotificationActionFromJSON(json: any): CommentMentionNotificationAction {
    return CommentMentionNotificationActionFromJSONTyped(json, false);
}

export function CommentMentionNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentMentionNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': CommentMentionNotificationActionDataFromJSON(json['data']),
    };
}

export function CommentMentionNotificationActionToJSON(value?: CommentMentionNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': CommentMentionNotificationActionDataToJSON(value.data),
    };
}

